import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=96ac74c2&scoped=true&lang=pug&"
import script from "./terms.vue?vue&type=script&lang=js&"
export * from "./terms.vue?vue&type=script&lang=js&"
import style0 from "./terms.vue?vue&type=style&index=0&id=96ac74c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ac74c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96ac74c2')) {
      api.createRecord('96ac74c2', component.options)
    } else {
      api.reload('96ac74c2', component.options)
    }
    module.hot.accept("./terms.vue?vue&type=template&id=96ac74c2&scoped=true&lang=pug&", function () {
      api.rerender('96ac74c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/terms/terms.vue"
export default component.exports